import React from "react";
import Select from "react-select";

const FormSelectHonrific = ({
    name,
    placeholder,
    value,
    onChange,
    disabled = false,
    label,
    className
}) => {
    const PRONOUNCE = [
        {
            label: "-",
            value: "-",
        },
        {
            label: "Mr.",
            value: "Mr.",
        },
        {
            label: "Ms.",
            value: "Ms.",
        },
        {
            label: "Mrs.",
            value: "Mrs.",
        },
        {
            label: "Mr./Ms.",
            value: "Mr./Ms.",
        },
    ];

    const selectedOption = PRONOUNCE.find(option => option.value === value)

    return (
        <>
            <Select
                placeholder={placeholder}
                classNamePrefix={className}
                disabled={disabled}
                styles={{
                    control: (baseStyles, isActive) => ({
                        ...baseStyles,
                        paddingTop: "",
                        paddingLeft: "8px",
                        paddingBotton: "0.75rem",
                        border: "none",
                        borderBottom: "1px solid #DBBE78",
                        borderColor: "#dbbe78",
                        height: "calc(3.5rem + 2px)",
                        borderRadius: "0.3rem",
                        background: "rgba(167, 167, 167, 0.1)",
                        fontSize: "14px",
                    }),
                }}
                autoComplete="off"
                onChange={onChange}
                getOptionLabel={option => option.label}
                options={PRONOUNCE}
                value={selectedOption}
            />
        </>
    );
};

export default FormSelectHonrific;
